import PutAway from '@/models/PutAway/PutAway';

export default class PutAwayFilter {

	constructor() {
		/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.putAwayDateFrom = '';
		this.putAwayDateTo = '';
		this.putAwayTypeId = '';
		this.putAwayHeaderId = '';
		this.putAwayTypeName = '';
		this.controlCardId = '';
		this.controlCardControlCardNumber = '';
		this.controlCardNumber = '';
		this.rackId = '';
		this.rackCode = '';
		this.remark = '';
		this.approvalId = '';
		this.approvalFirstName = '';
		this.isLocked = false;
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
		this.readyForPutaway = false;
		this.readyForFinishGoodQualityInspection = false;
		/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
			/*APP_APP_FILTER_CRITERIA*/
			id: '0',
			putAwayDateFrom: '0',
			putAwayDateTo: '0',
			putAwayTypeId: '0',
			putAwayHeaderId: '0',
			putAwayTypeName: '0',
			controlCardId: '0',
			controlCardControlCardNumber: '0',
			controlCardNumber: '0',
			rackId: '0',
			rackCode: '0',
			remark: '0',
			approvalId: '0',
			approvalFirstName: '0',
			isLocked: '0',
			isFromUpload: '0',
			isSavedToBackend: '0',
			/*END_APP_FILTER_CRITERIA*/
		};
	}

}